/**
 * This origin's storage as JSON, where it exists: a page's storage can be missing, full, or refused, and nothing here
 * depends on it, so a read answers null and a write does nothing in those cases.
 */
import { attempt } from "../shared/quietly";

export function readJSON<T>(key: string): T | null {
  const text = attempt(() => localStorage.getItem(key));
  if (text === null || text === undefined) return null;
  return attempt(() => JSON.parse(text) as T) ?? null;
}

export function writeJSON(key: string, value: unknown): void {
  attempt(() => localStorage.setItem(key, JSON.stringify(value)));
}

export function forget(key: string): void {
  attempt(() => localStorage.removeItem(key));
}
